// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-payment-css-PaymentSuccess__center--GJJqH{text-align:center}`, "",{"version":3,"sources":["webpack://./src/payment/css/PaymentSuccess.scss"],"names":[],"mappings":"AAAA,+CACI,iBAAA","sourcesContent":[".center {\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"center": `src-payment-css-PaymentSuccess__center--GJJqH`
};
export default ___CSS_LOADER_EXPORT___;
